<template>

    <section
        id="gallery"
        class="gallery"
    >

        <div class="container">

            <h2 class="gallery__title">
                {{ 'home_gallery' | staticTitle }}
            </h2>

            <p class="gallery__subtitle">
                {{ 'home_gallery' | staticContent }}
            </p>

            <div class="gallery__line"></div>

            <div class="gallery__grid">

                <article
                    v-for="(item, index) in galleryItems"
                    :key="index"
                    class="gallery__item"
                    @click="openLightbox(index)"
                >

                    <img
                        :src="item.hash | staticImg"
                        :alt="item.hash | staticTitle"
                    >

                </article>

            </div>
<!--
            <a
                href="#"
                class="gallery__link"
            >
                <span>
                    {{ 'home_gallery' | staticContentAlt }}
                </span>

                <span class="gallery__arrow">
                    →
                </span>
            </a>
-->
        </div>

        <div
            class="lightbox"
            :class="{ active: lightboxOpen }"
            @click.self="closeLightbox"
        >

            <button
                type="button"
                class="lightbox__close"
                aria-label="Close"
                @click="closeLightbox"
            >
                ×
            </button>

            <button
                type="button"
                class="lightbox__prev"
                aria-label="Previous image"
                @click="previousImage"
            >
                ‹
            </button>

            <div class="lightbox__content">

                <img
                    v-if="lightboxOpen"
                    :src="currentImage"
                    :alt="currentAlt"
                >

            </div>

            <button
                type="button"
                class="lightbox__next"
                aria-label="Next image"
                @click="nextImage"
            >
                ›
            </button>

        </div>

    </section>

</template>

<script>
export default {
    name: 'HomeGallery',

    data() {
        return {
            currentIndex: 0,
            lightboxOpen: false,

            galleryItems: [
                {
                    hash: 'gallery_1'
                },
                {
                    hash: 'gallery_2'
                },
                {
                    hash: 'gallery_3'
                },
                {
                    hash: 'gallery_4'
                },
                {
                    hash: 'gallery_5'
                },
                {
                    hash: 'gallery_6'
                }
            ]
        };
    },

    computed: {
        currentHash() {
            return this.galleryItems[this.currentIndex].hash;
        },

        currentImage() {
            return this.$options.filters.staticImg(this.currentHash);
        },

        currentAlt() {
            return this.$options.filters.staticTitle(this.currentHash);
        }
    },

    methods: {
        openLightbox(index) {
            this.currentIndex = index;
            this.lightboxOpen = true;
            document.body.style.overflow = 'hidden';
        },

        closeLightbox() {
            this.lightboxOpen = false;
            document.body.style.overflow = '';
        },

        previousImage() {
            this.currentIndex =
                this.currentIndex === 0
                    ? this.galleryItems.length - 1
                    : this.currentIndex - 1;
        },

        nextImage() {
            this.currentIndex =
                this.currentIndex === this.galleryItems.length - 1
                    ? 0
                    : this.currentIndex + 1;
        }
    },

    beforeDestroy() {
        document.body.style.overflow = '';
    }
};
</script>

<style lang="scss" scoped>
.gallery {
    background: var(--background);

    padding: 70px 20px;

    text-align: center;

    .container {
        width: 100%;
        max-width: 500px;

        margin: 0 auto;
    }

    &__title {
        font-family: 'Cormorant Garamond', serif;

        font-size: 2.1rem;
        font-weight: 700;

        line-height: 1.2;

        color: var(--text);
    }

    &__subtitle {
        margin-top: 8px;

        font-family: 'Poppins', sans-serif;

        font-size: .9rem;

        letter-spacing: 3px;

        text-transform: uppercase;

        color: #777;
    }

    &__line {
        width: 60px;
        height: 3px;

        margin: 20px auto 50px;

        background: var(--primary);
    }

    &__grid {
        display: grid;

        gap: 15px;
    }

    &__item {
        position: relative;

        overflow: hidden;

        border-radius: 8px;

        cursor: pointer;

        img {
            display: block;

            width: 100%;

            aspect-ratio: 4 / 3;

            object-fit: cover;

            transition: transform .5s ease;
        }

        &:hover img {
            transform: scale(1.05);
        }
    }

    &__link {
        display: flex;

        justify-content: center;
        align-items: center;

        gap: 10px;

        width: max-content;

        margin: 40px auto 0;

        color: var(--primary);

        font-size: 14px;
        font-weight: 700;

        text-decoration: none;
    }

    &__arrow {
        font-size: 22px;

        line-height: 1;

        transition: transform .2s ease;
    }

    &__link:hover &__arrow {
        transform: translateX(4px);
    }
}

.lightbox {
    position: fixed;

    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    z-index: 9999;

    display: flex;

    justify-content: center;
    align-items: center;

    padding: 40px;

    background: rgba(0, 0, 0, .92);

    opacity: 0;
    visibility: hidden;

    transition:
        opacity .3s ease,
        visibility .3s ease;

    &.active {
        opacity: 1;
        visibility: visible;
    }

    &__content {
        position: relative;

        max-width: 90vw;
        max-height: 90vh;

        img {
            display: block;

            max-width: 90vw;
            max-height: 85vh;

            width: auto;
            height: auto;

            object-fit: contain;

            border-radius: 4px;
        }
    }

    button {
        position: absolute;

        z-index: 2;

        border: none;

        background: none;

        color: var(--white);

        cursor: pointer;

        &:hover {
            color: var(--primary);
        }
    }

    &__close {
        top: 25px;
        right: 30px;

        font-size: 40px;

        line-height: 1;
    }

    &__prev,
    &__next {
        top: 50%;

        transform: translateY(-50%);

        font-size: 40px;

        padding: 20px;
    }

    &__prev {
        left: 20px;
    }

    &__next {
        right: 20px;
    }
}

@media (min-width: 768px) {
    .gallery {
        padding: 90px 20px;

        .container {
            max-width: 1200px;
        }

        &__title {
            font-size: 3rem;
        }

        &__grid {
            grid-template-columns: repeat(2, 1fr);

            gap: 20px;
        }
    }
}

@media (min-width: 1100px) {
    .gallery {

        &__grid {
            grid-template-columns: repeat(3, 1fr);
            grid-auto-rows: 220px;

            gap: 20px;
        }

        &__item img {
            width: 100%;
            height: 100%;

            aspect-ratio: auto;

            object-fit: cover;
        }
    }
}

@media (max-width: 768px) {
    .lightbox {
        padding: 20px;

        &__content img {
            max-width: 90vw;
            max-height: 80vh;
        }

        &__close {
            top: 15px;
            right: 18px;

            font-size: 34px;
        }

        &__prev,
        &__next {
            font-size: 28px;

            padding: 10px;
        }

        &__prev {
            left: 5px;
        }

        &__next {
            right: 5px;
        }
    }
}
</style>